/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Track_NoneInputs */



/**
* | output |
* | --- |
* | "No Track" |
*
* @param {Event_Track_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_track_none = /** @type {((inputs?: Event_Track_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Track_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun suivi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Track")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет пути")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无曲目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックなし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई ट्रैक नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem trilha")
	return /** @type {LocalizedString} */ ("No Track")
});